import "./__content.scss"; import "./__dot.scss"; import "./__image.scss"; import "./gallery.scss"

